import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Home.module.scss";
import trophia_logo from "../../assets/trophiaLogo.png";
import tatiana_photo from "../../assets/tatiana.jpeg";

// ── Data ──────────────────────────────────────────────────
const STATS = [
  { value: "500+", label: "Clients Transformed" },
  { value: "6+",   label: "Years of Experience"  },
  { value: "98%",  label: "Client Satisfaction"  },
  { value: "15+",  label: "Specialisations"       },
];

const SERVICES = [
  {
    emoji: "🥗",
    title: "Custom Meal Plans",
    desc:  "Personalised weekly plans built around your body composition, goals, and food preferences — no generic templates.",
  },
  {
    emoji: "📊",
    title: "Body Composition Analysis",
    desc:  "Track weight, body fat, muscle mass, and measurements over time with detailed progress insights.",
  },
  {
    emoji: "🏃",
    title: "Sports Nutrition",
    desc:  "Fuel performance with precision — pre/post-workout nutrition tailored to your training schedule.",
  },
  {
    emoji: "🤰",
    title: "Prenatal & Postnatal",
    desc:  "Safe, research-backed nutrition support throughout every stage of pregnancy and recovery.",
  },
  {
    emoji: "💊",
    title: "Supplement Guidance",
    desc:  "Cut through the noise. Evidence-based recommendations on what your body actually needs.",
  },
  {
    emoji: "🩺",
    title: "Medical Nutrition Therapy",
    desc:  "Specialised dietary management for diabetes, IBS, PCOS, high cholesterol, and more.",
  },
];

const STEPS = [
  { num: "01", title: "Book a Consultation", desc: "Schedule your first session — online or in-person, at a time that suits you." },
  { num: "02", title: "Full Assessment",      desc: "We analyse your body composition, health history, lifestyle, and goals." },
  { num: "03", title: "Your Custom Plan",     desc: "Receive a detailed weekly meal plan specially built for you." },
  { num: "04", title: "Track & Adjust",       desc: "Regular check-ins and plan updates as your body and goals evolve." },
];

const TESTIMONIALS = [
  {
    name:   "Sarah M.",
    role:   "Lost 18 kg in 5 months",
    avatar: "S",
    text:   "Tatiana completely changed my relationship with food. I never felt like I was on a diet — the plan was so enjoyable and realistic.",
  },
  {
    name:   "Karim A.",
    role:   "Athlete & Fitness Coach",
    avatar: "K",
    text:   "My performance improved dramatically. The sports nutrition approach Tatiana designed for me made a real difference in my recovery and energy.",
  },
  {
    name:   "Lina H.",
    role:   "Managed PCOS symptoms",
    avatar: "L",
    text:   "After years of struggling, Tatiana's plan helped me regulate my hormones and lose 12 kg. I finally feel in control of my health.",
  },
];



// ── Tatiana caricature ────────────────────────────────────
const TatianaCaricature = () => (
  <svg width="90" height="160" viewBox="0 0 90 160" fill="none" xmlns="http://www.w3.org/2000/svg"
    style={{ overflow: "visible" }}>
    <style>{`
      @keyframes wave {
        0%   { transform: rotate(-200deg); }
        30%  { transform: rotate(-190deg); }
        60%  { transform: rotate(-210deg); }
        100% { transform: rotate(-200deg); }
      }
      .waving-arm {
        transform-box: fill-box;
        transform-origin: 100% 0%;
        animation: wave 1.1s ease-in-out infinite;
      }
    `}</style>

    {/* ── Hair back layer ── */}
    <ellipse cx="45" cy="34" rx="22" ry="26" fill="#D4A843" />
    {/* curly hair falling left — gentle S-waves */}
    <path d="M24 40 Q10 54 18 72 Q26 90 12 108 Q14 118 20 118 Q20 106 28 88 Q36 70 22 54 Z" fill="#D4A843"/>
    {/* curly hair falling right — gentle S-waves */}
    <path d="M66 40 Q80 54 72 72 Q64 90 78 108 Q76 118 70 118 Q70 106 62 88 Q54 70 68 54 Z" fill="#D4A843"/>
    {/* hair shine */}
    <path d="M34 16 Q40 12 48 15" stroke="#F0C860" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>

    {/* ── Face ── */}
    <ellipse cx="45" cy="34" rx="17" ry="19" fill="#F5C9A0" />

    {/* ── Eyes ── */}
    <ellipse cx="38" cy="30" rx="3" ry="3.5" fill="white"/>
    <ellipse cx="52" cy="30" rx="3" ry="3.5" fill="white"/>
    <circle cx="38.8" cy="30.5" r="2" fill="#4A3020"/>
    <circle cx="52.8" cy="30.5" r="2" fill="#4A3020"/>
    <circle cx="39.5" cy="29.5" r="0.7" fill="white"/>
    <circle cx="53.5" cy="29.5" r="0.7" fill="white"/>
    {/* lashes */}
    <path d="M35 27.5 Q36 25.5 38 26.5" stroke="#3A2010" strokeWidth="0.9" strokeLinecap="round"/>
    <path d="M49 27.5 Q50 25.5 52 26.5" stroke="#3A2010" strokeWidth="0.9" strokeLinecap="round"/>
    {/* brows */}
    <path d="M34 25.5 Q38 23.5 41 25" stroke="#8B5E2A" strokeWidth="1.4" strokeLinecap="round" fill="none"/>
    <path d="M49 25 Q52 23.5 55 25.5" stroke="#8B5E2A" strokeWidth="1.4" strokeLinecap="round" fill="none"/>

    {/* ── Nose ── */}
    <path d="M44 34 Q43 38 45 39 Q47 38 46 34" stroke="#C8977A" strokeWidth="0.9" fill="none" strokeLinecap="round"/>

    {/* ── Smile / lips ── */}
    <path d="M39 43 Q45 48 51 43" stroke="#C0504A" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <path d="M39 43 Q45 45.5 51 43" fill="#E06060" opacity="0.5"/>

    {/* ── Ears ── */}
    <ellipse cx="27.5" cy="34" rx="3" ry="4" fill="#F2BF90"/>
    <ellipse cx="62.5" cy="34" rx="3" ry="4" fill="#F2BF90"/>

    {/* ── Neck ── */}
    <rect x="40" y="51" width="10" height="10" rx="2" fill="#F2BF90"/>

    {/* ── White robe body ── */}
    <path d="M36 60 Q29 63 27 70 Q25 78 29 86 Q26 94 26 108 Q26 130 29 134 L61 134 Q64 130 64 108 Q64 94 61 86 Q65 78 63 70 Q61 63 54 60 Z"
      fill="#F4F7F4" stroke="#D8E8D8" strokeWidth="1"/>

    {/* lapels */}
    <path d="M45 60 L38 60 L34 80 L45 72 Z" fill="white" stroke="#C8D8C8" strokeWidth="0.8"/>
    <path d="M45 60 L52 60 L56 80 L45 72 Z" fill="white" stroke="#C8D8C8" strokeWidth="0.8"/>

    {/* centre button line */}
    <line x1="45" y1="72" x2="45" y2="132" stroke="#C8D8C8" strokeWidth="0.8" strokeDasharray="2,3"/>
    {/* buttons */}
    <circle cx="45" cy="80"  r="1.5" fill="#C0D0C0"/>
    <circle cx="45" cy="92"  r="1.5" fill="#C0D0C0"/>
    <circle cx="45" cy="104" r="1.5" fill="#C0D0C0"/>
    <circle cx="45" cy="116" r="1.5" fill="#C0D0C0"/>

    {/* pocket left */}
    <rect x="29" y="95" width="12" height="10" rx="2" fill="white" stroke="#C0D0C0" strokeWidth="0.8"/>

    {/* subtle sheen */}
    <path d="M29 72 Q28 90 29 112" stroke="#E0EEE0" strokeWidth="2" strokeLinecap="round" opacity="0.8"/>

    {/* ── Shoulders — white robe ── */}
    <ellipse cx="28" cy="63" rx="7" ry="5" fill="#F0F5F0" stroke="#D0E0D0" strokeWidth="0.8"/>
    <ellipse cx="62" cy="63" rx="7" ry="5" fill="#F0F5F0" stroke="#D0E0D0" strokeWidth="0.8"/>

    {/* ── Right arm — white sleeve then skin ── */}
    <path d="M66 67 Q72 80 70 98" stroke="#F0F5F0" strokeWidth="7" strokeLinecap="round" fill="none"/>
    <path d="M70 92 Q71 96 70 100" stroke="#F2BF90" strokeWidth="6" strokeLinecap="round" fill="none"/>

    {/* ── Clipboard ── */}
    <rect x="62" y="86" width="20" height="26" rx="2" fill="#F5F0E0" stroke="#C8B870" strokeWidth="1.2"/>
    <rect x="68" y="83" width="9"  height="5"  rx="2" fill="#8B7340"/>
    <line x1="65" y1="95"  x2="78" y2="95"  stroke="#B0A070" strokeWidth="1"/>
    <line x1="65" y1="100" x2="78" y2="100" stroke="#B0A070" strokeWidth="1"/>
    <line x1="65" y1="105" x2="74" y2="105" stroke="#B0A070" strokeWidth="1"/>
    <path d="M65 90 Q68 87 71 90 Q68 93 65 90Z" fill="#4A7C40" opacity="0.8"/>

    {/* ── Legs — slim ── */}
    <path d="M36 134 Q35 145 35 158" stroke="#C8977A" strokeWidth="6" strokeLinecap="round" fill="none"/>
    <path d="M54 134 Q55 145 55 158" stroke="#C8977A" strokeWidth="6" strokeLinecap="round" fill="none"/>

    {/* ── Shoes ── */}
    <ellipse cx="35" cy="159" rx="6" ry="3" fill="#1A1A1A"/>
    <ellipse cx="55" cy="159" rx="6" ry="3" fill="#1A1A1A"/>

    {/* ── Hair front fringe — soft curly bumps ── */}
    <path d="M28 22 C31 12 35 9 38 15 C40 19 42 9 45 12 C48 9 50 19 52 15 C55 9 59 12 62 22"
      fill="#D4A843" stroke="#C09030" strokeWidth="0.5"/>

    {/* ── Name badge clipped to chest ── */}
    <rect x="48" y="72" width="18" height="12" rx="2" fill="#4A7C40" opacity="0.92"/>
    <text x="57" y="79" textAnchor="middle" fontSize="4.5" fontWeight="700"
      fontFamily="Arial, sans-serif" fill="white">RD</text>
    <text x="57" y="82.5" textAnchor="middle" fontSize="3.5"
      fontFamily="Arial, sans-serif" fill="#c8ffcc">Tatiana</text>

    {/* ── Left arm — waving (drawn last so it renders on top) ── */}
    <g className="waving-arm">
      <path d="M24 67 Q18 83 19 102" stroke="#F0F5F0" strokeWidth="7" strokeLinecap="round" fill="none"/>
      <path d="M19 96 Q18 100 19 104" stroke="#F2BF90" strokeWidth="6" strokeLinecap="round" fill="none"/>
      <ellipse cx="19" cy="105" rx="4.5" ry="3.5" fill="#F2BF90"/>
    </g>
  </svg>
);

// ── Component ─────────────────────────────────────────────
const Home = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={classes.page}>

      {/* ── Navbar ── */}
      <nav className={classes.nav}>
        <div className={classes.nav_logo}>
          <img src={trophia_logo} alt="trophia logo" className={classes.nav_logo_logo}/> 
        </div>

        <div className={classes.nav_links}>
          <a href="#services" className={classes.nav_link}>Services</a>
          <a href="#about"    className={classes.nav_link}>About</a>
          <a href="#process"  className={classes.nav_link}>How it works</a>
          <a href="#reviews"  className={classes.nav_link}>Reviews</a>
        </div>

        <div className={classes.nav_actions}>
          <button type="button" className={classes.nav_login_btn} onClick={() => navigate("/login")}>
            Log in
          </button>
          <button type="button" className={classes.nav_cta_btn} onClick={() => navigate("/login")}>
            Book a Session
          </button>
        </div>

        {/* mobile burger */}
        <button
          type="button"
          className={classes.nav_burger}
          onClick={() => setMenuOpen(true)}
          aria-label="Open menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* ── Mobile drawer ── */}
      {menuOpen && (
        <div className={classes.mobile_backdrop} onClick={closeMenu} />
      )}
      <div className={`${classes.mobile_drawer} ${menuOpen ? classes.mobile_drawer_open : ""}`}>
        <div className={classes.mobile_drawer_top}>
          <div className={classes.nav_logo}>
          <img src={trophia_logo} alt="trophia logo" className={classes.nav_logo_logo}/> 
        </div>
          <button type="button" className={classes.mobile_close} onClick={closeMenu} aria-label="Close menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className={classes.mobile_links}>
          <a href="#services" className={classes.mobile_link} onClick={closeMenu}>Services</a>
          <a href="#about"    className={classes.mobile_link} onClick={closeMenu}>About</a>
          <a href="#process"  className={classes.mobile_link} onClick={closeMenu}>How it works</a>
          <a href="#reviews"  className={classes.mobile_link} onClick={closeMenu}>Reviews</a>
        </div>

        <div className={classes.mobile_actions}>
          <button type="button" className={classes.nav_login_btn} onClick={() => { closeMenu(); navigate("/login"); }}>
            Log in
          </button>
          <button type="button" className={classes.nav_cta_btn} onClick={() => { closeMenu(); navigate("/login"); }}>
            Book a Session
          </button>
        </div>
      </div>

      <div className={classes.page_body}>
      {/* ── Hero ── */}
      <section className={classes.hero}>
        {/* floating decorative blobs */}
        <div className={`${classes.blob} ${classes.blob1}`} />
        <div className={`${classes.blob} ${classes.blob2}`} />
        <div className={`${classes.blob} ${classes.blob3}`} />

        {/* floating food pills */}
        <div className={`${classes.pill} ${classes.pill1}`}>🥑 Avocado</div>
        <div className={`${classes.pill} ${classes.pill2}`}>🫐 Blueberries</div>
        <div className={`${classes.pill} ${classes.pill3}`}>🥦 Broccoli</div>
        <div className={`${classes.pill} ${classes.pill4}`}>🍋 Lemon</div>
        <div className={`${classes.pill} ${classes.pill5}`}>🐟 Salmon</div>

        {/* dumbbell */}
        <div className={classes.dumbbell_tl}>🏋️</div>

        {/* Tatiana caricature */}
        <div className={classes.tatiana_float}>
          <TatianaCaricature />
        </div>

        <div className={classes.hero_content}>
          <span className={classes.hero_badge}>
            <span className={classes.hero_badge_dot} />
            Registered Dietitian
          </span>
          <h1 className={classes.hero_title}>
            Eat smarter.<br />
            <span className={classes.hero_title_accent}>Live stronger.</span>
          </h1>
          <p className={classes.hero_subtitle}>
            Science-backed nutrition plans designed for your body, your goals, and your life —
            by <strong>Tatiana Karam</strong>, Registered Dietitian & Nutrition Therapist.
          </p>

          <div className={classes.hero_actions}>
            <button type="button" className={classes.hero_primary_btn} onClick={() => navigate("/login")}>
              Start Your Journey
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
            <a href="#about" className={classes.hero_ghost_btn}>
              Meet Tatiana
            </a>
          </div>

          <div className={classes.hero_trust}>
            <div className={classes.trust_avatars}>
              {["A","B","C","D"].map((l) => (
                <div key={l} className={classes.trust_avatar}>{l}</div>
              ))}
            </div>
            <span className={classes.trust_text}><strong>500+</strong> clients already transformed</span>
          </div>
        </div>

        {/* hero visual card */}
        <div className={classes.hero_card}>
          <div className={classes.hero_card_top}>
            <img src={tatiana_photo} alt="Tatiana Karam" className={classes.hero_avatar} />
            <div>
              <div className={classes.hero_card_name}>Tatiana Karam</div>
              <div className={classes.hero_card_role}>Registered Dietitian</div>
            </div>
            <span className={classes.hero_card_badge}>● Online</span>
          </div>

          <div className={classes.hero_card_divider} />

          <div className={classes.hero_card_label}>Today's Meal Plan</div>
          {[
            { emoji: "🥣", meal: "Breakfast", food: "Oats + Banana + Eggs" },
            { emoji: "🍗", meal: "Lunch",     food: "Chicken + Quinoa" },
            { emoji: "🥗", meal: "Dinner",    food: "Salmon + Greens" },
          ].map((m) => (
            <div key={m.meal} className={classes.hero_card_meal}>
              <span className={classes.hero_card_meal_emoji}>{m.emoji}</span>
              <div>
                <div className={classes.hero_card_meal_name}>{m.meal}</div>
                <div className={classes.hero_card_meal_food}>{m.food}</div>
              </div>
              <span className={classes.hero_card_check}>✓</span>
            </div>
          ))}

          <div className={classes.hero_card_divider} />

          <div className={classes.hero_card_macros}>
            {[
              { label: "Calories", val: "1,840" },
              { label: "Protein",  val: "142g"  },
              { label: "Fat",      val: "58g"   },
            ].map((m) => (
              <div key={m.label} className={classes.hero_card_macro}>
                <span className={classes.hero_card_macro_val}>{m.val}</span>
                <span className={classes.hero_card_macro_label}>{m.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className={classes.stats}>
        {STATS.map((s) => (
          <div key={s.label} className={classes.stat_item}>
            <span className={classes.stat_value}>{s.value}</span>
            <span className={classes.stat_label}>{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── Services ── */}
      <section className={classes.section} id="services">
        <div className={classes.section_header}>
          <span className={classes.section_badge}>What I offer</span>
          <h2 className={classes.section_title}>Nutrition for every goal</h2>
          <p className={classes.section_sub}>From weight management to athletic performance — every plan is built around you.</p>
        </div>
        <div className={classes.services_grid}>
          {SERVICES.map((s) => (
            <div key={s.title} className={classes.service_card}>
              <div className={classes.service_emoji}>{s.emoji}</div>
              <h3 className={classes.service_title}>{s.title}</h3>
              <p className={classes.service_desc}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── About ── */}
      <section className={classes.about} id="about">
        <div className={classes.about_visual}>
          <div className={classes.about_avatar_wrap}>
            <img src={tatiana_photo} alt="Tatiana Karam" className={classes.about_avatar} />
            <div className={classes.about_ring1} />
            <div className={classes.about_ring2} />
          </div>
          <div className={classes.about_float_card}>
            <span className={classes.about_float_emoji}>🎓</span>
            <div>
              <div className={classes.about_float_title}>MSc Clinical Nutrition</div>
              <div className={classes.about_float_sub}>Université Saint-Joseph de Beyrouth</div>
            </div>
          </div>
          <div className={`${classes.about_float_card} ${classes.about_float_card2}`}>
            <span className={classes.about_float_emoji}>🏅</span>
            <div>
              <div className={classes.about_float_title}>6+ Years Experience</div>
              <div className={classes.about_float_sub}>Clinical & Sports Nutrition</div>
            </div>
          </div>
        </div>

        <div className={classes.about_content}>
          <span className={classes.section_badge}>About Tatiana</span>
          <h2 className={classes.section_title}>Your health is personal.<br />So is the plan.</h2>
          <p className={classes.about_text}>
            Hi, I'm <strong>Tatiana Karam</strong>, a registered dietitian with over 6 years of experience
            helping individuals build a healthier, more sustainable relationship with food. I'm also a
            physio-nutrition specialist and phytotherapist, combining nutrition science with therapeutic
            and holistic approaches to support your overall well-being.
          </p>
          <p className={classes.about_text}>
            My approach is science-based, personalized, and realistic. I don't believe in one-size-fits-all
            plans. I design strategies that fit your lifestyle, preferences, and goals, so you can achieve
            results that actually last. Because the best plan isn't the perfect one — it's the one you can
            truly stick to.
          </p>
          <div className={classes.about_tags}>
            {["Therapeutic Nutrition","Weight Management","Sports Nutrition","Hormonal & Metabolic Health","Clinical Care","Phytotherapy"].map((t) => (
              <span key={t} className={classes.about_tag}>{t}</span>
            ))}
          </div>
          <button type="button" className={classes.hero_primary_btn} onClick={() => navigate("/login")}>
            Book a Consultation
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      {/* ── How it works ── */}
      <section className={classes.section} id="process">
        <div className={classes.section_header}>
          <span className={classes.section_badge}>The process</span>
          <h2 className={classes.section_title}>How it works</h2>
          <p className={classes.section_sub}>Simple, structured, and built around you from day one.</p>
        </div>
        <div className={classes.steps_grid}>
          {STEPS.map((s, i) => (
            <div key={s.num} className={classes.step_card}>
              <div className={classes.step_num}>{s.num}</div>
              {i < STEPS.length - 1 && <div className={classes.step_connector} />}
              <h3 className={classes.step_title}>{s.title}</h3>
              <p className={classes.step_desc}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section className={classes.reviews_section} id="reviews">
        <div className={classes.section_header}>
          <span className={classes.section_badge}>Real results</span>
          <h2 className={classes.section_title}>What clients say</h2>
        </div>
        <div className={classes.reviews_grid}>
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className={classes.review_card}>
              <div className={classes.review_stars}>{"★".repeat(5)}</div>
              <p className={classes.review_text}>"{t.text}"</p>
              <div className={classes.review_author}>
                <div className={classes.review_avatar}>{t.avatar}</div>
                <div>
                  <div className={classes.review_name}>{t.name}</div>
                  <div className={classes.review_role}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className={classes.cta_section}>
        <div className={`${classes.blob} ${classes.cta_blob1}`} />
        <div className={`${classes.blob} ${classes.cta_blob2}`} />
        <div className={classes.cta_content}>
          <h2 className={classes.cta_title}>Ready to start?</h2>
          <p className={classes.cta_sub}>Your personalised nutrition plan is one click away.</p>
          <button type="button" className={classes.cta_btn} onClick={() => navigate("/login")}>
            Book Your First Session
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className={classes.footer}>
        <div className={classes.footer_top}>
          <div className={classes.footer_brand}>
            <div className={classes.nav_logo}>
          <img src={trophia_logo} alt="trophia logo" className={classes.nav_logo_footer}/> 
        </div>
            <p className={classes.footer_tagline}>Science-backed nutrition.<br />Real, lasting results.</p>
          </div>
          <div className={classes.footer_links_group}>
            <div className={classes.footer_col}>
              <div className={classes.footer_col_title}>Contact Us</div>
              <span className={classes.footer_link}>Tatiana_Karam@hotmail.com</span>
              <span className={classes.footer_link}>+961 71 923 322</span>
              <span className={classes.footer_link}>Beirut, Lebanon</span>
            </div>
          </div>
        </div>
        <div className={classes.footer_bottom}>
          <span>© {new Date().getFullYear()} Trophia.  All rights reserved.</span>
          <br/><br/>
          <span>Developed by Georgio Bejjani.  </span>
        </div>
      </footer>
      </div>

    </div>
  );
};

export default Home;
